import { createSelector } from "reselect";
import get from "lodash/get";

const identityVerificationDomain = state =>
  get(state, "form.IdentityVerificationForm.values", {});

// ***************************************************************
// ************** IdentityVerificationForm selectors ******************
// ***************************************************************

export const identityVerificationSelector = createSelector(
  identityVerificationDomain,
  identityVerification => identityVerification
);

// ***************************************************************
// ************** IdentityVerificationForm makeSelect *****************
// ***************************************************************

export const makeSelectIdentityVerificationForm = () =>
  identityVerificationSelector;
